import React, { useMemo, useRef, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Container, Box, Typography, Grid, Card, CardContent, Checkbox, Avatar, Divider, Stack, IconButton, Tooltip, Tabs, Tab, ThemeProvider, createTheme, Chip, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Popover, Menu, MenuItem, Select, } from "@mui/material";
import { QuestionAnswer, Description, AddShoppingCart, Inventory2, CurrencyRupee, Schedule, PeopleAlt, TrendingUp, TrendingDown, Close, Apps as AppsIcon, LocalShipping, CalendarMonth, DateRange, Timeline, MoreVert, ShoppingCartCheckout, ShoppingCart, KeyboardArrowDown, } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import FilterList from "@mui/icons-material/FilterList";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import axios from "axios";
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, LabelList, Tooltip as ReTooltip, PieChart, Pie, Cell, Rectangle, LineChart, Line, } from "recharts";
import { DTZ, formatWithTZ } from "../utils/TimeZone";

const formatINR = (num) => {
    const n = Number(num) || 0;
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,  // Ensures at least 2 decimals
        maximumFractionDigits: 2,  // Limits to exactly 2 decimals
    }).format(n);
};

// export const KPICardWithTrend = ({ icon: Icon, title, value, subtitle, color = "#00B894", trend = "up", onClick, sparkData }) => {
//   const fallback = useMemo(
//     () => [{ v: 38 }, { v: 52 }, { v: 48 }, { v: 68 }, { v: 74 }, { v: 90 }],
//     []
//   );

//   const data = useMemo(() => {
//     if (!Array.isArray(sparkData) || sparkData.length === 0) return fallback;

//     const allZero = sparkData.every((item) => (item?.v ?? 0) === 0);
//     if (allZero) {
//       return sparkData.map(() => ({ v: 0 }));
//     }
//     return sparkData;
//   }, [sparkData, fallback]);

//   const gradientId = `grad-${color.replace("#", "")}`;
//   const glowId = `glow-${color.replace("#", "")}`;

//   const CustomTooltipLocal = ({ active, payload }) => {
//     if (!active || !payload?.[0]) return null;

//     const data = payload[0].payload;
//     const fullValue = data.value || 0;
//     const label = data.label || "Unknown";

//     return (
//       <motion.div
//         initial={{ opacity: 0, scale: 0.9, y: -8 }}
//         animate={{ opacity: 1, scale: 1, y: 0 }}
//         style={{
//           background: "rgba(15, 23, 42, 0.95)",
//           backdropFilter: "blur(16px)",
//           border: "1px solid rgba(255,255,255,0.1)",
//           borderRadius: 16,
//           padding: "12px 16px",
//           boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
//           color: "white",
//         }}
//       >
//         <div style={{ fontWeight: 800, fontSize: 16 }}> {formatINR(fullValue)} </div>
//         <div style={{ fontSize: 12.5, opacity: 0.8, marginTop: 4 }}> {label} </div>
//       </motion.div>
//     );
//   };

//   const CustomBar = (props) => {
//     const { x, y, width, height, payload } = props;
//     const isZero = payload.v === 0;
//     const minHeight = 3;
//     const finalHeight = isZero ? minHeight : height;
//     const finalY = isZero ? y + height - minHeight : y;

//     return (
//       <Rectangle
//         x={x}
//         y={finalY}
//         width={width}
//         height={finalHeight}
//         fill={props.fill}
//         rx={8}
//         ry={8}
//       />
//     );
//   };

//   // Determine badge background and border color based on trend
//   const badgeBg = trend === "up" ? "#10b98118" : trend === "down" ? "#ef444418" : "#94a3b818";
//   const badgeBorder = trend === "up" ? "#10b98144" : trend === "down" ? "#ef444444" : "#94a3b844";

//   return (
//     <Card
//       onClick={onClick}
//       elevation={0}
//       sx={{
//         height: "100%",
//         minHeight: { xs: 160, sm: 170, md: 180 },
//         overflow: "hidden",
//         position: "relative",
//         transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
//         boxShadow: `0 6px 24px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.6)`,
//         borderRadius: 3,
//         cursor: "pointer",
//       }}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           inset: 0,
//           background: "#f9fafb",
//           pointerEvents: "none",
//           border: `2.5px solid ${color}22`,
//           borderRadius: 3,
//         }}
//       />

//       <CardContent sx={{
//         p: { xs: 1.8, sm: 2 },
//         pt: { xs: 1, sm: 1 },
//         height: "100%",
//         display: "flex",
//         flexDirection: "column"
//       }}>
//         <motion.div whileHover={{ y: -2, scale: 1.02 }} transition={{ type: "spring", stiffness: 400, damping: 28 }}>
//           <Card
//             elevation={0}
//             sx={{
//               borderRadius: 3,
//               background: "rgba(255, 255, 255, 0.92)",
//               backdropFilter: "blur(12px)",
//               border: `1px solid ${color}22`,
//               boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
//               position: "relative",
//               overflow: "hidden", // Ensures badge doesn't spill out
//             }}
//           >
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: { xs: 1, sm: 2, md: 3 },      // Move it higher on smaller screens
//                 right: { xs: 2, sm: 4, md: 6 },    // Pull it in from the right edge on mobile
//                 zIndex: -1, // Reduce vertical padding
//                 display: "flex",
//                 alignItems: "center",
//                 fontSize: { xs: "0.38rem", sm: "0.44rem", md: "0.48rem" }, // Smaller font on mobile
//                 fontWeight: 600,
//                 color: trend === "up" ? "#059669" : trend === "down" ? "#dc2626" : "#64748b",
//                 maxWidth: { xs: "45%", sm: "55%", md: "none" }, // Limit width on small screens
//                 overflow: "hidden",
//                 whiteSpace: "nowrap",
//                 textOverflow: "ellipsis",
//                 pointerEvents: "none", // Prevent badge from interfering with card click
//               }}
//             >
//               {subtitle}
//             </Box>

//             <CardContent sx={{ p: 2, pt: 0.5, pb: 1.5, "&:last-child": { pb: 1.5 } }}>
//               <Stack direction="row" spacing={2} alignItems="center" mb={0.5}>
//                 <Box
//                   sx={{
//                     width: { xs: 36, sm: 40 },
//                     height: { xs: 36, sm: 40 },
//                     borderRadius: 3,
//                     background: `linear-gradient(135deg, ${color}33, ${color}11)`,
//                     border: `2px solid ${color}44`,
//                     boxShadow: `0 8px 20px ${color}44`,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Icon sx={{ fontSize: { xs: 18, sm: 20 }, color }} />
//                 </Box>

//                 <Box sx={{ minWidth: 0, }}>
//                   <Typography variant="subtitle1" fontWeight={700} color="#0f172a" fontSize="0.95rem" letterSpacing="-0.3px">
//                     {title}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontSize: { xs: "1.5rem", sm: "1.7rem", md: "1.8rem" },
//                       fontWeight: 500,
//                       lineHeight: 1.1,
//                       background: `linear-gradient(90deg, ${color}, ${color}ee)`,
//                       backgroundClip: "text",
//                       WebkitBackgroundClip: "text",
//                       color: "transparent",
//                       letterSpacing: "-1px",
//                     }}
//                   >
//                     1,00,00,00,00,00
//                   </Typography>
//                 </Box>
//               </Stack>

//               {/* Optional: You can now leave this empty or use for something else */}
//               {/* Removed the old subtitle from here since it's now in the top-right badge */}
//             </CardContent>
//           </Card>
//         </motion.div>

//         <Box sx={{ height: 70, position: "relative" }}>
//           <ResponsiveContainer width="100%" height="100%">
//             <LineChart data={data} margin={{ top: 6, right: 10, bottom: 6, left: 10 }}>
//               <defs>
//                 <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor={color} stopOpacity={0.9} />
//                   <stop offset="100%" stopColor={color} stopOpacity={0.25} />
//                 </linearGradient>

//                 <filter id={glowId} height="300%" width="300%" x="-100%" y="-100%">
//                   <feGaussianBlur stdDeviation="3" result="blur" />
//                   <feFlood floodColor={color} floodOpacity={0.35} />
//                   <feComposite in2="blur" operator="in" />
//                   <feMerge>
//                     <feMergeNode />
//                     <feMergeNode in="SourceGraphic" />
//                   </feMerge>
//                 </filter>
//               </defs>

//               <ReTooltip content={<CustomTooltipLocal />} cursor={{ stroke: color + "44", strokeWidth: 2 }} />

//               <Line
//                 type="monotone"
//                 dataKey="v"
//                 stroke={color}
//                 strokeWidth={3}
//                 fill="none"
//                 dot={false}
//                 activeDot={{ r: 6, stroke: color, strokeWidth: 3, fill: "#fff" }}
//                 isAnimationActive={true}
//                 animationDuration={1400}
//                 filter={`url(#${glowId})`}
//               />

//               {/* Optional subtle area fill below the line */}
//               <Line
//                 type="monotone"
//                 dataKey="v"
//                 stroke="none"
//                 fill={`url(#${gradientId})`}
//                 fillOpacity={0.3}
//                 isAnimationActive={true}
//                 animationDuration={1400}
//               />
//             </LineChart>
//           </ResponsiveContainer>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

export const KPICardWithTrend = ({ iconImage, title, value, subtitle, color = "#00B894", trend = "up", onClick, sparkData, highlight = false }) => {
    const fallback = useMemo(
        () => [{ v: 38 }, { v: 52 }, { v: 48 }, { v: 68 }, { v: 74 }, { v: 90 }],
        []
    );

    const data = useMemo(() => {
        if (!Array.isArray(sparkData) || sparkData.length === 0) return fallback;

        const allZero = sparkData.every((item) => (item?.v ?? 0) === 0);
        if (allZero) {
            return sparkData.map(() => ({ v: 0 }));
        }
        return sparkData;
    }, [sparkData, fallback]);

    const gradientId = `grad-${color.replace("#", "")}`;
    const glowId = `glow-${color.replace("#", "")}`;

    const CustomTooltipLocal = ({ active, payload }) => {
        if (!active || !payload?.[0]) return null;

        const data = payload[0].payload;
        const fullValue = data.value || 0;
        const label = data.label || "Unknown";

        return (
            <motion.div initial={{ opacity: 0, scale: 0.9, y: -8 }} animate={{ opacity: 1, scale: 1, y: 0 }} style={{ background: "rgba(15, 23, 42, 0.95)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "12px 16px", boxShadow: "0 20px 40px rgba(0,0,0,0.4)", color: "white", }} >
                <div style={{ fontWeight: 800, fontSize: 16 }}> {formatINR(fullValue)} </div>
                <div style={{ fontSize: 12.5, opacity: 0.8, marginTop: 4 }}> {label} </div>
            </motion.div>
        );
    };

    const CustomBar = (props) => {
        const { x, y, width, height, payload } = props;
        const isZero = payload.v === 0;
        const minHeight = 3;
        const finalHeight = isZero ? minHeight : height;
        const finalY = isZero ? y + height - minHeight : y;

        return (
            <Rectangle x={x} y={finalY} width={width} height={finalHeight} fill={props.fill} rx={8} ry={8} />
        );
    };

    // Determine badge background and border color based on trend (kept for potential future use)
    const badgeBg = trend === "up" ? "#10b98118" : trend === "down" ? "#ef444418" : "#94a3b818";
    const badgeBorder = trend === "up" ? "#10b98144" : trend === "down" ? "#ef444444" : "#94a3b844";

    // ── Stylish tinted tile — every card takes on its own `color` (already
    // passed in per-stat from Home2.js) via a soft gradient wash, a colored
    // top accent bar, a glowing gradient icon chip, and a colored glow
    // shadow, instead of flat white/grey. The highlighted "Total Sales" tile
    // stays fully filled/solid so it still reads as the primary KPI. Purely
    // visual — all data/trend/onClick logic above is unchanged.
    return (
        <Box
            onClick={onClick}
            sx={{
                height: "100%",
                minHeight: { xs: 96, sm: 102 },
                borderRadius: "16px",
                position: "relative",
                overflow: "hidden",
                border: `1px solid ${color}2A`,
                background: highlight
                    ? `linear-gradient(150deg, ${color} 0%, ${color}CC 100%)`
                    : `linear-gradient(160deg, ${color}17 0%, #FFFFFF 65%)`,
                boxShadow: highlight ? `0 12px 26px ${color}55` : `0 6px 16px ${color}26`,
                cursor: "pointer",
                p: 1.5,
                pt: 1.75,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 0.75,
                // Low-end-device smoothness: promote to its own GPU layer up
                // front (transform: translateZ(0) + will-change) so the
                // hover lift/shadow transition doesn't force a layout
                // recalculation on every frame, and use a shorter/cheaper
                // transition instead of animating box-shadow's full blur
                // (box-shadow transitions are expensive to rasterize on
                // weak GPUs) — only transform is animated on hover now.
                transform: "translateZ(0)",
                willChange: "transform",
                transition: "transform 0.18s ease",
                "&:hover": {
                    transform: "translateY(-2px) translateZ(0)",
                },
            }}
        >
            {/* Top accent bar */}
            <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: highlight ? "rgba(255,255,255,0.5)" : color }} />

            {/* Soft glow blob */}
            <Box sx={{ position: "absolute", top: -18, right: -18, width: 64, height: 64, borderRadius: "50%", background: highlight ? "rgba(255,255,255,0.16)" : `${color}22`, pointerEvents: "none" }} />

            <Stack direction="row" alignItems="center" spacing={1} sx={{ position: "relative" }}>
                <Box sx={{
                    width: 32, height: 32, borderRadius: "10px",
                    background: highlight ? "rgba(255,255,255,0.22)" : `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
                    boxShadow: highlight ? "none" : `0 4px 10px ${color}55`,
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                    <img src={iconImage} alt={title} style={{ width: "52%", height: "52%", objectFit: "contain", filter: "brightness(0) invert(1)" }} />
                </Box>
                <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: highlight ? "rgba(255,255,255,0.9)" : "#475569", flexShrink: 1 }} noWrap>
                    {title}
                </Typography>
            </Stack>

            <Box sx={{ minWidth: 0, position: "relative" }}>
                <Typography sx={{ fontSize: { xs: 15, sm: 16.5 }, fontWeight: 800, color: highlight ? "#FFFFFF" : "#0F172A", lineHeight: 1.15, letterSpacing: "-0.2px" }} noWrap>
                    {value}
                </Typography>
                <Box sx={{ mt: "3px" }}>{subtitle}</Box>
            </Box>
        </Box>
    );
};

const PIE_COLORS = [
    "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
    "#ec4899", "#06b6d4", "#f97316", "#6366f1", "#84cc16"
];

export const CLIENT_PIE_COLORS = [
    "#039BE5", "#00897B", "#FFB300", "#F4511E", "#5E35B1", "#7CB342", "#546E7A", "#00ACC1", "#FB8C00", "#C0CA33",
    "#6D4C41", "#AD1457", "#263238", "#E53935", "#1E88E5", "#43A047", "#8E24AA", "#FDD835", "#D81B60", "#3949AB",
    "#6A1B9A", "#1B5E20", "#F9A825", "#1565C0", "#827717", "#006064", "#FF8F00", "#004D40", "#BF360C", "#37474F",
    "#33691E", "#E65100", "#3E2723", "#424242", "#880E4F", "#0277BD", "#311B92", "#283593", "#757575", "#546E7A"

];

export const PRODUCT_PIE_COLORS = [
    "#6D4C41", "#3949AB", "#8E24AA", "#F4511E", "#D81B60", "#757575", "#039BE5", "#FFB300", "#00897B", "#43A047",
    "#7CB342", "#C0CA33", "#FDD835", "#00ACC1", "#FB8C00", "#5E35B1", "#33691E", "#1E88E5", "#546E7A", "#263238",
    "#AD1457", "#6A1B9A", "#283593", "#1565C0", "#0277BD", "#006064", "#004D40", "#1B5E20", "#E53935", "#827717",
    "#F9A825", "#FF8F00", "#E65100", "#BF360C", "#3E2723", "#424242", "#37474F", "#880E4F", "#4A148C", "#311B92"
];

export const EMPLOYEE_PIE_COLORS = [
    "#FF6D00", "#F50057", "#D500F9", "#651FFF", "#3D5AFE", "#FFAB00", "#00B0FF", "#00E5FF", "#1DE9B6", "#00E676",
    "#76FF03", "#C6FF00", "#FFEA00", "#FFC400", "#FF9100", "#FF3D00", "#795548", "#9E9E9E", "#607D8B", "#212121",
    "#C51162", "#AA00FF", "#6200EA", "#304FFE", "#2962FF", "#0091EA", "#00B8D4", "#00BFA5", "#00C853", "#64DD17",
    "#AEEA00", "#FFD600", "#2979FF", "#FF1744", "#DD2C00", "#4E342E", "#616161", "#455A64", "#880E4F", "#1A237E"
];


export const InfoCard = ({ title, children, icon: Icon, color = "#3b82f6", chartData = [], colors = [], period = "today", limit = 5, onPeriodChange, onLimitChange, }) => (
    <Card elevation={0}
        sx={{
            // box-shadow removed from the hover transition here — animating
            // box-shadow forces the browser to re-rasterize the shadow on
            // every frame, which is one of the costliest transitions on
            // low-end/integrated GPUs, especially on a card this large. The
            // hover state now just swaps the shadow value instantly (no
            // "transition" declared), keeping the same visual affordance
            // without the per-frame repaint cost.
            background: "white", borderRadius: "14px", border: "1px solid #F3F4F6", overflow: "hidden", boxShadow: "0 2px 6px rgba(15,23,42,0.05)", maxHeight: { xs: "650px", sm: "690px", md: "720px" }, display: "flex", flexDirection: "column", mb: 2,
            "&:hover": { boxShadow: "0 6px 16px rgba(15,23,42,0.08)", },
        }}
    >
        <CardContent sx={{ p: { xs: 2.5 } }}>
            <Box sx={{ width: "100%" }}>
                {/* ── Header — small icon chip + title + rounded limit pill, mirrors reonBookMobile homemaster.jsx's cardHeader/dropdownButton ── */}
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.25}>
                    <Stack direction="row" alignItems="center" spacing={1.25}>
                        <Box sx={{ width: 30, height: 30, borderRadius: "9px", bgcolor: "#EBF3FF", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Icon sx={{ fontSize: 16, color: "#1877F2" }} />
                        </Box>
                        <Typography fontWeight={700} color="#111827" fontSize="1rem" letterSpacing="0.1px"> {title} </Typography>
                    </Stack>

                    <Select
                        value={limit}
                        onChange={(e) => { const newLimit = Number(e.target.value) || 5; onLimitChange && onLimitChange(newLimit); }}
                        IconComponent={KeyboardArrowDown}
                        variant="standard"
                        disableUnderline
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    mt: 0.75,
                                    borderRadius: "12px",
                                    boxShadow: "0 12px 32px rgba(15,23,42,0.14)",
                                    border: "1px solid #EEF1F6",
                                    overflow: "hidden",
                                },
                            },
                        }}
                        sx={{
                            borderRadius: "20px",
                            background: "#EBF3FF",
                            fontWeight: 600,
                            fontSize: "0.78rem",
                            color: "#1877F2",
                            pl: 1.6,
                            pr: 0.5,
                            "& .MuiSelect-select": { py: 0.65, pr: "26px !important", display: "flex", alignItems: "center" },
                            "& .MuiSelect-icon": { color: "#1877F2", right: 8 },
                        }}
                    >
                        <MenuItem value={5} sx={{ fontSize: "0.82rem", fontWeight: 600, "&.Mui-selected": { background: "#EBF3FF", color: "#1877F2" } }}>Top 5</MenuItem>
                        <MenuItem value={10} sx={{ fontSize: "0.82rem", fontWeight: 600, "&.Mui-selected": { background: "#EBF3FF", color: "#1877F2" } }}>Top 10</MenuItem>
                        <MenuItem value={15} sx={{ fontSize: "0.82rem", fontWeight: 600, "&.Mui-selected": { background: "#EBF3FF", color: "#1877F2" } }}>Top 15</MenuItem>
                    </Select>

                </Stack>

                {/* Divider */}
                <Box sx={{ height: 1, background: "#F3F4F6" }} />

                {/* Period Buttons — compact segmented pill row */}
                <Stack direction="row" spacing={0.6} sx={{ mt: 1.25, background: "#F3F4F6", borderRadius: "10px", p: "3px" }}>
                    {["today", "weekly", "monthly", "yearly"].map((p) => {
                        const isActive = p === period;
                        return (
                            <Button key={p} disableElevation size="small" onClick={() => onPeriodChange && onPeriodChange(p)}
                                sx={{
                                    flex: 1, textTransform: "none", fontWeight: isActive ? 700 : 500, borderRadius: "8px", py: 0.6, fontSize: "0.76rem", bgcolor: isActive ? "#F7FAFF" : "transparent", color: isActive ? "#111827" : "#6B7280", boxShadow: isActive ? "0 1px 3px rgba(15,23,42,0.06)" : "none",
                                    "&:hover": { bgcolor: isActive ? "#F7FAFF" : "rgba(0,0,0,0.03)", },
                                }}
                            >
                                {p === "today" ? "Today" : p.charAt(0).toUpperCase() + p.slice(1)}
                            </Button>
                        );
                    })}
                </Stack>
            </Box>

            {/* NEW POLAR AREA CHART BLOCK */}
            {chartData.length > 0 && (
                <Box sx={{ height: 240, p: 1, borderRadius: 3, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)", mt: 2 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <div
                            style={{
                                transform: "scaleY(0.72)",
                                transformOrigin: "center",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <PieChart width={400} height={320}>

                                {/* DEPTH LAYERS FOR 3D EFFECT - IMPROVED */}
                                {Array.from({ length: 15 }).map((_, depth) => (
                                    <Pie
                                        key={`depth-${depth}`}
                                        data={chartData}
                                        dataKey="value"
                                        cx="50%"
                                        cy={95 + depth * 2.8}
                                        innerRadius={0}
                                        outerRadius={95}
                                        startAngle={90}
                                        endAngle={-270}
                                        paddingAngle={0}
                                        isAnimationActive={false}
                                    >
                                        {chartData.map((entry, index) => (
                                            <Cell
                                                key={`depth-${depth}-${index}`}
                                                fill={colors[index % colors.length]}
                                                opacity={0.1 + depth * 0.042}
                                                stroke="none"
                                            />
                                        ))}
                                    </Pie>
                                ))}

                                {/* TOP PIE SURFACE - IMPROVED */}
                                <Pie
                                    data={chartData}
                                    cx="50%"
                                    cy="33%"
                                    innerRadius={0}
                                    outerRadius={95}
                                    paddingAngle={1}
                                    dataKey="value"
                                    startAngle={90}
                                    endAngle={-270}
                                    stroke="rgba(255,255,255,0.7)"
                                    strokeWidth={2}
                                    animationBegin={0}
                                    // Shortened from 800ms — with 3 of these
                                    // pie charts (each stacked on 15 static
                                    // depth layers) animating at once on
                                    // period/limit change, the sweep-in
                                    // animation was the single heaviest
                                    // recurring repaint on the page. A
                                    // quicker, cheaper animation keeps the
                                    // effect without holding the frame rate
                                    // down as long on weak devices.
                                    animationDuration={350}
                                    animationEasing="ease-out"
                                >
                                    {chartData.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={colors[index % colors.length]}
                                        />
                                    ))}
                                </Pie>

                                {/* ENHANCED TOOLTIP */}
                                <ReTooltip
                                    content={({ active, payload }) => {
                                        if (active && payload && payload.length) {
                                            const item = payload[0].payload;
                                            const index = chartData.findIndex(d => d.name === item.name);

                                            return (
                                                <div
                                                    style={{
                                                        backgroundColor: "rgba(15,23,42,1)",
                                                        border: `4px solid ${colors[index % colors.length]}`,
                                                        borderRadius: 14,
                                                        padding: "12px 16px",
                                                        color: "white",
                                                        fontSize: 13,
                                                        boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                                                    }}
                                                >
                                                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{item.name}</div>
                                                    <div style={{ marginBottom: 2 }}>Amount: <strong>{formatINR(item.value)}</strong></div>
                                                    <div>Share: <strong>{item.percentage.toFixed(2)}%</strong></div>
                                                </div>
                                            );
                                        }
                                        return null;
                                    }}
                                />
                            </PieChart>
                        </div>
                    </ResponsiveContainer>

                </Box>
            )}
        </CardContent>

        <Box
            sx={{
                flexGrow: 1, overflowY: "auto", px: { xs: 2.5, sm: 3 }, pb: 1, height: { xs: "240px", sm: "360px", md: "300px" },
                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-track": { background: "transparent" },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(0,0,0,0.2)", borderRadius: "3px", },
            }}
        >
            {children}
        </Box>
    </Card>
);

export const PremiumFloatingMenu = ({ open, setOpen, onNewOrderClick, onDispatchClick, onRecentActivityClick }) => {
    const navigate = useNavigate();

    const innerItems = [
        { Icon: AddShoppingCart, label: "New Order", color: "#3b82f6", action: onNewOrderClick },
        { Icon: LocalShipping, label: "Dispatch", color: "#10b981", action: onDispatchClick },
        { Icon: Schedule, label: "Recent Activity", color: "#8b5cf6", action: onRecentActivityClick },
    ];

    const outerItems = [
        { Icon: Description, label: "Quotations", color: "#f59e0b", path: "/main/v2/orderDetail-stepper" },
        { Icon: QuestionAnswer, label: "Inquiries", color: "#a855f7", path: "/main/v4/inquiry-details" },
        { Icon: Inventory2, label: "Pending Dispatch", color: "#ef4444", path: "/main/v2/sale-invoice" },
        { Icon: PeopleAlt, label: "Clients", color: "#06b6d4", path: "/clients" },
        { Icon: TrendingUp, label: "Analytics", color: "#ec4899", path: "/analytics" },
        { Icon: CurrencyRupee, label: "Revenue", color: "#10b981", path: "/main/v2/sale-invoice" },
    ];

    const handleClick = (item) => {
        setOpen(false);
        if (item.action) item.action();
        if (item.path) navigate(item.path);
    };

    const innerRadius = 60;
    const outerRadius = 140;

    return (
        <>
            <AnimatePresence>
                {open && (
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.32)", backdropFilter: "blur(12px)", zIndex: 1199 }} > </motion.div>
                )}
            </AnimatePresence>

            <Box sx={{ position: "fixed", top: 85, right: 25, zIndex: 1200 }}>
                <AnimatePresence>
                    {open && (
                        <Box sx={{ position: "absolute", bottom: -295, right: -208, width: outerRadius * 2, height: outerRadius * 2, pointerEvents: "none", zIndex: 1200, opacity: 1, transform: "scale(1)", transition: "all 0.45s ease-out", }}>
                            <motion.div initial={{ rotate: 90 }} animate={{ rotate: 180 }} transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }} style={{ position: "absolute", bottom: 0, right: 0, width: "100%", height: "100%", transform: "scaleY(-1)" }} >
                                {innerItems.map((item, i) => {
                                    const totalAngle = 150;
                                    const startAngle = -120;
                                    const angle = startAngle + (i * totalAngle) / (innerItems.length - 1);
                                    const rad = angle * (Math.PI / 180);
                                    const centerX = outerRadius * 2;
                                    const centerY = outerRadius * 2;
                                    const x = centerX + innerRadius * Math.cos(rad) - 33;
                                    const y = centerY + innerRadius * Math.sin(rad) - 33;

                                    return (
                                        <motion.div key={`inner-${i}`} initial={{ scale: 0, rotate: -180 }} animate={{ scale: 1, rotate: 180 }} exit={{ scale: 0, rotate: 180 }} transition={{ delay: 0.2 + i * 0.07, type: "spring", stiffness: 340, damping: 26 }} whileHover={{ scale: 1.28 }} whileTap={{ scale: 0.94 }} style={{ position: "absolute", left: x, top: y, pointerEvents: "auto", transform: "scaleY(-1)" }} >
                                            <Tooltip title={item.label} arrow placement="left">
                                                <IconButton onClick={() => handleClick(item)} sx={{ width: 52, height: 52, background: `linear-gradient(135deg, ${item.color}, ${item.color}ee)`, color: "white", boxShadow: `0 16px 40px ${item.color}90`, border: "4px solid rgba(255,255,255,0.4)", backdropFilter: "blur(12px)", "&:hover": { transform: "translateY(-8px)", boxShadow: `0 28px 60px ${item.color}bb` }, }} >
                                                    <item.Icon sx={{ fontSize: 28 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </motion.div>
                                    );
                                })}

                                {outerItems.map((item, i) => {
                                    const totalAngle = 140;
                                    const startAngle = -115;
                                    const angle = startAngle + (i * totalAngle) / (outerItems.length - 1);
                                    const rad = angle * (Math.PI / 180);
                                    const centerX = outerRadius * 2;
                                    const centerY = outerRadius * 2;
                                    const x = centerX + outerRadius * Math.cos(rad) - 33;
                                    const y = centerY + outerRadius * Math.sin(rad) - 33;

                                    return (
                                        <motion.div key={`outer-${i}`} initial={{ scale: 0, rotate: -180 }} animate={{ scale: 1, rotate: 180 }} exit={{ scale: 0, rotate: 180 }} transition={{ delay: 0.4 + i * 0.06, type: "spring", stiffness: 320, damping: 28 }} whileHover={{ scale: 1.28 }} whileTap={{ scale: 0.94 }} style={{ position: "absolute", left: x, top: y, pointerEvents: "auto", transform: "scaleY(-1)" }} >
                                            <Tooltip title={item.label} arrow placement="left">
                                                <IconButton onClick={() => handleClick(item)} sx={{ width: 52, height: 52, background: `linear-gradient(135deg, ${item.color}, ${item.color}ee)`, color: "white", boxShadow: `0 16px 40px ${item.color}90`, border: "4px solid rgba(255,255,255,0.4)", backdropFilter: "blur(12px)", "&:hover": { transform: "translateY(-8px)", boxShadow: `0 28px 60px ${item.color}bb` }, }} >
                                                    <item.Icon sx={{ fontSize: 28 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </motion.div>
                                    );
                                })}
                            </motion.div>
                        </Box>
                    )}
                </AnimatePresence>

                <motion.div whileTap={{ scale: 0.92 }}>
                    <IconButton onClick={() => setOpen((prev) => !prev)} sx={{ width: 54, height: 54, p: 0, minWidth: 0, display: "flex", alignItems: "center", justifyContent: "center", background: open ? "linear-gradient(135deg, #ef4444, #dc2626)" : "linear-gradient(135deg, #6366f1, #4f46e5)", color: "white", boxShadow: open ? "0 18px 50px rgba(239,68,68,0.75)" : "0 18px 50px rgba(99,102,241,0.75)", border: "5px solid rgba(255,255,255,0.3)", backdropFilter: "blur(14px)", transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)", "&:hover": { transform: "scale(1.15)" }, }} >
                        <motion.div animate={{ rotate: open ? 135 : 0 }} transition={{ duration: 0.4, ease: "easeInOut" }} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", }} >
                            {open ? <Close sx={{ fontSize: 35 }} /> : <AppsIcon sx={{ fontSize: 35 }} />}
                        </motion.div>
                    </IconButton>
                </motion.div>
            </Box>
        </>
    );
};





// export const UserActivityPopup = React.memo(({
//     open,
//     onClose,
//     userName,
//     activities = []
// }) => {

//     const displayActivities = activities;

//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//             {/* ===== DIALOG HEADER ===== */}
//             <DialogTitle sx={{ pb: 1 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box>
//                         <Typography variant="h6" fontWeight={800} color="#1e293b">
//                             Activity Timeline
//                         </Typography>
//                         <Typography fontSize={12} color="#64748b" sx={{ mt: 0.5 }}>
//                             {userName || "User Activities"}
//                         </Typography>
//                     </Box>
//                     <IconButton
//                         onClick={onClose}
//                         sx={{
//                             color: "#64748b",
//                             "&:hover": { bgcolor: "#e2e8f0", color: "#1e293b" }
//                         }}
//                     >
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             {/* ===== DIALOG CONTENT ===== */}
//             <DialogContent dividers sx={{ p: 0 }}>
//                 {displayActivities.length === 0 ? (
//                     <Box sx={{ py: 8, textAlign: "center" }}>
//                         <Typography color="text.secondary" fontWeight={500}>
//                             No activity available
//                         </Typography>
//                     </Box>
//                 ) : (
//                     <Box>
//                         {/* TABLE HEADER */}
//                         <Box
//                             sx={{
//                                 display: "grid",
//                                 gridTemplateColumns: "1fr 1.5fr 1.3fr 0.8fr",
//                                 gap: 2,
//                                 px: 2.5,
//                                 py: 1.2,
//                                 alignItems: "center",
//                                 borderBottom: "2px solid #e2e8f0",
//                                 backgroundColor: "#f8fafc",
//                                 position: "sticky",
//                                 top: 0,
//                                 zIndex: 10,
//                             }}
//                         >
//                             <Typography
//                                 sx={{
//                                     fontSize: "11px",
//                                     fontWeight: 700,
//                                     color: "#64748b",
//                                     textTransform: "uppercase",
//                                     letterSpacing: "0.5px"
//                                 }}
//                             >
//                                 Client
//                             </Typography>
//                             <Typography
//                                 sx={{
//                                     fontSize: "11px",
//                                     fontWeight: 700,
//                                     color: "#64748b",
//                                     textTransform: "uppercase",
//                                     letterSpacing: "0.5px"
//                                 }}
//                             >
//                                 Activity
//                             </Typography>
//                             <Typography
//                                 sx={{
//                                     fontSize: "11px",
//                                     fontWeight: 700,
//                                     color: "#64748b",
//                                     textTransform: "uppercase",
//                                     letterSpacing: "0.5px"
//                                 }}
//                             >
//                                 Date & Time
//                             </Typography>
//                             <Typography
//                                 sx={{
//                                     fontSize: "11px",
//                                     fontWeight: 700,
//                                     color: "#64748b",
//                                     textTransform: "uppercase",
//                                     letterSpacing: "0.5px",
//                                     textAlign: "center"
//                                 }}
//                             >
//                                 Status
//                             </Typography>
//                         </Box>

//                         {/* TABLE ROWS */}
//                         <Stack spacing={0}>
//                             {displayActivities.map((item, index) => (
//                                 <Box
//                                     key={index}
//                                     sx={{
//                                         display: "grid",
//                                         gridTemplateColumns: "1fr 1.5fr 1.3fr 0.8fr",
//                                         gap: 2,
//                                         px: 2.5,
//                                         py: 1.5,
//                                         alignItems: "center",
//                                         borderBottom: "1px solid #e2e8f0",
//                                         backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
//                                         transition: "all 0.2s ease",
//                                         "&:hover": {
//                                             backgroundColor: "#f1f5f9",
//                                             boxShadow: "inset 0 0 12px rgba(0,0,0,0.02)"
//                                         }
//                                     }}
//                                 >
//                                     {/* COLUMN 1: CLIENT NAME */}
//                                     <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
//                                         <Avatar
//                                             sx={{
//                                                 width: 40,
//                                                 height: 40,
//                                                 bgcolor: "#e0e7ff",
//                                                 color: "#4f46e5",
//                                                 fontSize: "0.9rem",
//                                                 fontWeight: 700,
//                                                 flexShrink: 0
//                                             }}
//                                         >
//                                             {(item.client || item.leadFrom || "U").charAt(0).toUpperCase()}
//                                         </Avatar>
//                                         <Box sx={{ minWidth: 0 }}>
//                                             <Typography
//                                                 sx={{
//                                                     fontWeight: 700,
//                                                     fontSize: "13px",
//                                                     color: "#0f172a",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis"
//                                                 }}
//                                             >
//                                                 {item.client || item.leadFrom || "Unknown"}
//                                             </Typography>
//                                             {item.leadTo && (
//                                                 <Typography
//                                                     sx={{
//                                                         fontSize: "11px",
//                                                         color: "#64748b",
//                                                         whiteSpace: "nowrap",
//                                                         overflow: "hidden",
//                                                         textOverflow: "ellipsis"
//                                                     }}
//                                                 >
//                                                     To: {item.leadTo}
//                                                 </Typography>
//                                             )}
//                                         </Box>
//                                     </Box>

//                                     {/* COLUMN 2: ACTIVITY MESSAGE */}
//                                     <Box sx={{ minWidth: 0 }}>
//                                         <Typography
//                                             sx={{
//                                                 fontSize: "13px",
//                                                 color: "#0f172a",
//                                                 fontWeight: 500,
//                                                 lineHeight: 1.4,
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: 2,
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis"
//                                             }}
//                                         >
//                                             {item.message || "No message"}
//                                         </Typography>
//                                     </Box>

//                                     {/* COLUMN 3: DATE & TIME */}
//                                     <Box sx={{ minWidth: 0 }}>
//                                         <Typography
//                                             sx={{
//                                                 fontSize: "12px",
//                                                 color: "#0f172a",
//                                                 fontWeight: 500,
//                                                 whiteSpace: "nowrap",
//                                                 overflow: "hidden",
//                                                 textOverflow: "ellipsis"
//                                             }}
//                                         >
//                                             {item.displayTime || item.ist_datetime || "N/A"}
//                                         </Typography>
//                                         {item.ist_datetime && !item.displayTime && (
//                                             <Typography
//                                                 sx={{
//                                                     fontSize: "11px",
//                                                     color: "#64748b",
//                                                     whiteSpace: "nowrap",
//                                                     overflow: "hidden",
//                                                     textOverflow: "ellipsis"
//                                                 }}
//                                             >
//                                                 {new Date(item.ist_datetime).toLocaleDateString("en-IN")}
//                                             </Typography>
//                                         )}
//                                     </Box>

//                                     {/* COLUMN 4: STATUS CHIP */}
//                                     <Box sx={{ display: "flex", justifyContent: "center", minWidth: 0 }}>
//                                         <Chip
//                                             label="Completed"
//                                             size="small"
//                                             sx={{
//                                                 fontSize: "11px",
//                                                 fontWeight: 600,
//                                                 height: "auto",
//                                                 py: 0.4,
//                                                 bgcolor: "#d1fae5",
//                                                 color: "#059669",
//                                                 border: "none",
//                                                 minWidth: 0
//                                             }}
//                                         />
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Stack>
//                     </Box>
//                 )}
//             </DialogContent>

//             {/* ===== DIALOG ACTIONS ===== */}
//             <DialogActions sx={{ px: 2.5, py: 1.5, gap: 1 }}>
//                 <Button
//                     onClick={onClose}
//                     variant="contained"
//                     sx={{
//                         textTransform: "none",
//                         fontWeight: 600,
//                         borderRadius: 2,
//                         bgcolor: "#1e293b",
//                         color: "#ffffff",
//                         "&:hover": {
//                             bgcolor: "#0f172a"
//                         }
//                     }}
//                 >
//                     Close
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// });

// UserActivityPopup.displayName = "UserActivityPopup";





// export const UserActivityPopup = React.memo(({
//     open,
//     onClose,
//     userName,
//     activities = []
// }) => {

//     /* ================= FILTER STATES ================= */
//     const [searchText, setSearchText] = React.useState("");
//     const [sortOrder, setSortOrder] = React.useState("desc");
//     const [activityType, setActivityType] = React.useState("all");

//     const [clientAnchor, setClientAnchor] = React.useState(null);
//     const [activityAnchor, setActivityAnchor] = React.useState(null);

//     /* ================= FILTER LOGIC ================= */
//     const displayActivities = React.useMemo(() => {
//         let data = [...activities];

//         if (searchText) {
//             data = data.filter(item =>
//                 (item.client || item.leadFrom || "")
//                     .toLowerCase()
//                     .includes(searchText.toLowerCase())
//             );
//         }

//         if (activityType !== "all") {
//             data = data.filter(item =>
//                 (item.message || "").toLowerCase().includes(activityType)
//             );
//         }

//         data.sort((a, b) => {
//             const d1 = new Date(a.ist_datetime || 0).getTime();
//             const d2 = new Date(b.ist_datetime || 0).getTime();
//             return sortOrder === "asc" ? d1 - d2 : d2 - d1;
//         });

//         return data;
//     }, [activities, searchText, activityType, sortOrder]);

//     return (
//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//             {/* ===== DIALOG HEADER ===== */}
//             <DialogTitle sx={{ pb: 1 }}>
//                 <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Box>
//                         <Typography variant="h6" fontWeight={800}>
//                             Activity Timeline
//                         </Typography>
//                         <Typography fontSize={12} color="#64748b">
//                             {userName || "User Activities"}
//                         </Typography>
//                     </Box>
//                     <IconButton onClick={onClose}>
//                         <CloseIcon />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             {/* ===== DIALOG CONTENT ===== */}
//             <DialogContent dividers sx={{ p: 0 }}>
//                 <Box>
//                     {/* ===== TABLE HEADER (ALWAYS RENDERED) ===== */}
//                     <Box
//                         sx={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1.5fr 1.3fr 0.8fr",
//                             px: 2.5,
//                             py: 1.2,
//                             backgroundColor: "#f8fafc",
//                             borderBottom: "2px solid #e2e8f0",
//                             alignItems: "center",
//                             position: "sticky",
//                             top: 0,
//                             zIndex: 2
//                         }}
//                     >
//                         {/* CLIENT */}
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
//                                 Client
//                             </Typography>
//                             <IconButton size="small" onClick={(e) => setClientAnchor(e.currentTarget)}>
//                                 <SearchIcon fontSize="inherit" />
//                             </IconButton>
//                         </Box>

//                         {/* ACTIVITY */}
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
//                                 Activity
//                             </Typography>
//                             <IconButton size="small" onClick={(e) => setActivityAnchor(e.currentTarget)}>
//                                 <FilterList fontSize="inherit" />
//                             </IconButton>
//                         </Box>

//                         {/* DATE */}
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                             <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
//                                 Date & Time
//                             </Typography>
//                             <IconButton
//                                 size="small"
//                                 onClick={() =>
//                                     setSortOrder(prev => (prev === "asc" ? "desc" : "asc"))
//                                 }
//                             >
//                                 {sortOrder === "asc" ? (
//                                     <ArrowUpward fontSize="inherit" />
//                                 ) : (
//                                     <ArrowDownward fontSize="inherit" />
//                                 )}
//                             </IconButton>
//                         </Box>

//                         {/* STATUS */}
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, textAlign: "center" }}>
//                             Status
//                         </Typography>
//                     </Box>

//                     {/* ===== TABLE BODY ===== */}
//                     {displayActivities.length === 0 ? (
//                         <Box sx={{ py: 8, textAlign: "center" }}>
//                             <Typography color="text.secondary">
//                                 No activity found for selected filter
//                             </Typography>
//                         </Box>
//                     ) : (
//                         <Stack spacing={0}>
//                             {displayActivities.map((item, index) => (
//                                 <Box
//                                     key={index}
//                                     sx={{
//                                         display: "grid",
//                                         gridTemplateColumns: "1fr 1.5fr 1.3fr 0.8fr",
//                                         px: 2.5,
//                                         py: 1.5,
//                                         borderBottom: "1px solid #e2e8f0"
//                                     }}
//                                 >
//                                     {/* CLIENT */}
//                                     <Typography>{item.client || item.leadFrom}</Typography>

//                                     {/* MESSAGE */}
//                                     <Typography>{item.message}</Typography>

//                                     {/* DATE */}
//                                     <Typography>{item.displayTime || item.ist_datetime}</Typography>

//                                     {/* STATUS */}
//                                     <Chip label="Completed" size="small" />
//                                 </Box>
//                             ))}
//                         </Stack>
//                     )}
//                 </Box>
//             </DialogContent>

//             {/* ===== POPUPS ===== */}
//             <Popover
//                 open={Boolean(clientAnchor)}
//                 anchorEl={clientAnchor}
//                 onClose={() => setClientAnchor(null)}
//             >
//                 <Box sx={{ p: 2, width: 200 }}>
//                     <TextField
//                         fullWidth
//                         size="small"
//                         placeholder="Search client"
//                         value={searchText}
//                         onChange={(e) => setSearchText(e.target.value)}
//                     />
//                 </Box>
//             </Popover>

//             <Menu
//                 anchorEl={activityAnchor}
//                 open={Boolean(activityAnchor)}
//                 onClose={() => setActivityAnchor(null)}
//             >
//                 {["all", "inquiry", "follow", "quotation", "order", "challan", "invoice"].map(v => (
//                     <MenuItem
//                         key={v}
//                         onClick={() => {
//                             setActivityType(v);
//                             setActivityAnchor(null);
//                         }}
//                     >
//                         {v.toUpperCase()}
//                     </MenuItem>
//                 ))}
//             </Menu>

//             {/* ===== ACTIONS ===== */}
//             <DialogActions>
//                 <Button onClick={onClose} variant="contained">
//                     Close
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );

// });

// UserActivityPopup.displayName = "UserActivityPopup";

export const UserActivityPopup = React.memo(({
    open,
    onClose,
    userName,
    activities = []
}) => {

    /* ================= FILTER STATES ================= */
    const [searchText, setSearchText] = React.useState("");
    const [sortOrder, setSortOrder] = React.useState("desc");
    const [activityTypes, setActivityTypes] = React.useState([]);

    const [clientAnchor, setClientAnchor] = React.useState(null);
    const [activityAnchor, setActivityAnchor] = React.useState(null);

    const ACTIVITY_OPTIONS = [
        "inquiry",
        "follow",
        "quotation",
        "order",
        "challan",
        "invoice"
    ];

    /* ================= FILTER LOGIC (UNCHANGED) ================= */
    const displayActivities = React.useMemo(() => {
        let data = [...activities];

        if (searchText) {
            data = data.filter(item =>
                (item.client || item.leadFrom || "")
                    .toLowerCase()
                    .includes(searchText.toLowerCase())
            );
        }

        if (activityTypes.length > 0) {
            data = data.filter(item =>
                activityTypes.some(type =>
                    (item.message || "").toLowerCase().includes(type)
                )
            );
        }

        data.sort((a, b) => {
            const d1 = new Date(a.ist_datetime || 0).getTime();
            const d2 = new Date(b.ist_datetime || 0).getTime();
            return sortOrder === "asc" ? d1 - d2 : d2 - d1;
        });

        return data;
    }, [activities, searchText, activityTypes, sortOrder]);

    /* ================= HANDLERS (UNCHANGED) ================= */
    const toggleActivityType = (type) => {
        setActivityTypes(prev =>
            prev.includes(type)
                ? prev.filter(t => t !== type)
                : [...prev, type]
        );
    };

    const clearFilters = () => {
        setSearchText("");
        setActivityTypes([]);
        setSortOrder("desc");
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderRadius: 2, overflow: 'hidden' }
            }}
        >
            {/* ================= HEADER ================= */}
            <DialogTitle sx={{
                pb: 1,
                pt: 2.5,
                px: 3,
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa'
            }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box>
                        <Typography variant="h6" fontWeight={700} color="text.primary">
                            Activity Timeline
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mt={0.5}>
                            {userName || "User Activities"}
                        </Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* ================= CONTENT ================= */}
            <DialogContent dividers sx={{ p: 0, maxHeight: '70vh', overflowY: 'auto' }}>
                <Box>

                    {/* ===== TABLE HEADER ===== */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "1.4fr 2.2fr 1.4fr",
                            px: 3.5,
                            py: 1.8,
                            backgroundColor: "#f8f9fa",
                            borderBottom: "2px solid #dee2e6",
                            alignItems: "center",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                        }}
                    >
                        {/* CLIENT */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                                Client
                            </Typography>
                            <IconButton
                                size="small"
                                onClick={(e) => setClientAnchor(e.currentTarget)}
                                sx={{ p: 0.5 }}
                            >
                                <SearchIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        {/* ACTIVITY */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                                Activity
                            </Typography>
                            <IconButton
                                size="small"
                                onClick={(e) => setActivityAnchor(e.currentTarget)}
                                sx={{ p: 0.5 }}
                            >
                                <FilterList fontSize="small" />
                            </IconButton>
                        </Box>

                        {/* DATE */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "flex-end" }}>
                            <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                                Date & Time
                            </Typography>
                            <IconButton
                                size="small"
                                onClick={() => setSortOrder(prev => prev === "asc" ? "desc" : "asc")}
                                sx={{ p: 0.5 }}
                            >
                                {sortOrder === "asc" ? (
                                    <ArrowUpward fontSize="small" />
                                ) : (
                                    <ArrowDownward fontSize="small" />
                                )}
                            </IconButton>
                        </Box>
                    </Box>

                    {/* ===== BODY ===== */}
                    {displayActivities.length === 0 ? (
                        <Box sx={{ py: 10, textAlign: "center", color: "text.secondary" }}>
                            <Typography variant="body1" fontWeight={500}>
                                No activities found
                            </Typography>
                            <Typography variant="body2" mt={1} color="text.secondary">
                                Try adjusting your filters
                            </Typography>

                            {(searchText || activityTypes.length > 0 || sortOrder === "asc") && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{ mt: 3 }}
                                    onClick={clearFilters}
                                >
                                    Clear Filters
                                </Button>
                            )}
                        </Box>
                    ) : (
                        <Stack spacing={0}>
                            {displayActivities.map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "1.4fr 2.2fr 1.4fr",
                                        px: 3.5,
                                        py: 2,
                                        borderBottom: "1px solid #f0f0f0",
                                        // Named properties (not "all") so hovering
                                        // a row in a potentially long list doesn't
                                        // make the browser watch every CSS
                                        // property, including grid layout ones.
                                        transition: "background-color 0.12s ease, transform 0.12s ease",
                                        "&:hover": {
                                            backgroundColor: "#f8f9fa",
                                            transform: "translateY(2px)",
                                        },
                                    }}
                                >
                                    <Typography variant="body2" fontWeight={500} color="text.primary">
                                        {item.client || item.leadFrom || "—"}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        {item.message || "No description"}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        textAlign="right"
                                        fontFamily="monospace"
                                    >
                                        {formatWithTZ(item.ist_datetime)}
                                    </Typography>
                                </Box>
                            ))}
                        </Stack>
                    )}
                </Box>
            </DialogContent>

            {/* ================= CLIENT SEARCH POPOVER ================= */}
            <Popover
                open={Boolean(clientAnchor)}
                anchorEl={clientAnchor}
                onClose={() => setClientAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <Box sx={{ p: 2, width: 280 }}>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Search client name..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        autoFocus
                        variant="outlined"
                    />
                </Box>
            </Popover>

            {/* ================= ACTIVITY FILTER MENU ================= */}
            <Menu
                anchorEl={activityAnchor}
                open={Boolean(activityAnchor)}
                onClose={() => setActivityAnchor(null)}
            >
                {ACTIVITY_OPTIONS.map(type => (
                    <MenuItem
                        key={type}
                        onClick={() => toggleActivityType(type)}
                        sx={{ py: 0.5 }}
                    >
                        <Checkbox
                            checked={activityTypes.includes(type)}
                            size="small"
                        />
                        <Typography variant="body2" textTransform="capitalize">
                            {type}
                        </Typography>
                    </MenuItem>
                ))}
                <Divider />
                <MenuItem onClick={() => setActivityTypes([])}>
                    <Typography variant="body2" color="error">
                        Clear Activity Filter
                    </Typography>
                </MenuItem>
            </Menu>

            {/* ================= FOOTER ACTIONS ================= */}
            <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: 100 }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
});

UserActivityPopup.displayName = "UserActivityPopup";